const paginationDefaults = {
  firstPage: 1,
  maxEllipsisPageCount: 7,
  pageBuffer: 4,
};

const PASTE_NEXT_TITLE = "Go to next page";
const PASTE_PREVIOUS_TITLE = "Go to previous page";

export default {
  paginationDefaults,
  PASTE_NEXT_TITLE,
  PASTE_PREVIOUS_TITLE,
};
